import {
  SET_COMPANIES,
  UPDATE_COMPANY_STOR,
  SET_SPOT_TO_EDIT,
  RESET_ACTIVE_TYPE,
} from "../constants";

const initialState = {
  organizations: [],
  businesses: [],
  media: [],
  government: [],
  hotSpot: [],
  greenSpot: [],
  categories: [],
  spotToEdit: false,
  spotActiveToEdit: "", //not use
};

const updateState = (state, actionCompany) => {
  const index = state.indexOf(
    state.find((company) => company._id === actionCompany._id)
  );
  state.splice(index, 1, actionCompany);
  return state;
};

export function companies(state = initialState, action) {
  const newState = { ...state };

  switch (action.type) {
    case SET_COMPANIES:
      newState.organizations = action.companies[0];
      newState.businesses = action.companies[1];
      newState.media = action.companies[2];
      newState.government = action.companies[3];
      newState.hotSpot = action.companies[4];
      newState.greenSpot = action.companies[5];
      newState.news = action.companies[6];
      return newState;
    case RESET_ACTIVE_TYPE:
      newState.spotActiveToEdit = ""; //not use
    case UPDATE_COMPANY_STOR:
      if (action.companyType === "NGO") {
        newState.organizations = updateState(
          [...newState.organizations],
          action.company
        );
        return newState;
      }
      if (action.companyType === "business") {
        newState.businesses = updateState(
          [...newState.businesses],
          action.company
        );
        return newState;
      }
      if (action.companyType === "media") {
        newState.media = updateState([...newState.media], action.company);
        return newState;
      }
      if (action.companyType === "government") {
        newState.government = updateState(
          [...newState.government],
          action.company
        );
        return newState;
      }
      if (action.companyType === "hotSpot") {
        newState.hotSpot = updateState([...newState.hotSpot], action.company);
        return newState;
      }
      if (action.companyType === "greenSpot") {
        newState.greenSpot = updateState(
          [...newState.greenSpot],
          action.company
        );
        return newState;
      }
      return state;
    case SET_SPOT_TO_EDIT:
      newState.spotActiveToEdit = action.spot?.type; //not use
      newState.spotToEdit = action.spot;
      return newState;
    default:
      return state;
  }
}
